import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useBatchDetail(id) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/batches/${id}`,
          method: "GET",
          // params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useBatchDetail;
